import dayjs from 'dayjs'

export default {
    transform(data) {
        return JSON.parse(data).map(({ date, startTime, endTime }) => ({
            date,
            startTime,
            endTime,
            from: dayjs(startTime, 'HH:mm').diff(dayjs().startOf('day'), 'minutes'),
            to: dayjs(endTime, 'HH:mm').diff(dayjs().startOf('day'), 'minutes'),
        }))
    },
}
